import React from "react";
import {Table} from "@material-ui/core";
import Grid from "@material-ui/core/Grid";
import Typography from "@material-ui/core/Typography";
import Paper from "@material-ui/core/Paper";
import {withStyles} from "@material-ui/styles";
import moment from "moment";
import Accordion from "@material-ui/core/Accordion";
import ExpansionPanelSummary from "@material-ui/core/ExpansionPanelSummary";
import {ExpandMoreTwoTone} from "@material-ui/icons";
import ExpansionPanelDetails from "@material-ui/core/ExpansionPanelDetails";
import SwmsPartThree from "./SwmsPartThree";
import TableHead from "@material-ui/core/TableHead";
import TableBody from "@material-ui/core/TableBody";
import MuiTable from "../common/MuiTable";
import PropTypes from "prop-types";

const classes = (() => ({
    root: {
        width: '100%',
        overflowX: 'auto',
    },
    table: {
        minWidth: 650,
    },
    fullWidth : {
        width: '100%',
        borderRadius: 0
    },
}));

const muiColumnsHazards = [
    { title: 'Job Step', field: 'jobStep', headerStyle: { width: "10%", background: "lightblue" }},
    { title: 'Consequence',
        field: 'inherentRiskConsequence',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: { insignificant : 'Insignificant / Acceptable' , minor : 'Minor', moderate: 'Moderate', major: 'Major', catastrophic: 'Catastrophic' },
    },
    { title: 'Likelihood',
        field: 'inherentRiskLikelihood',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: { certain : 'Almost certain' , likely : 'Likely', possible: 'Possible', unlikely: 'Unlikely', rare: 'Rare' },
    },
    {
        title: 'Inherent Risk Rating',
        field: 'calculatedInherentRisk',
        editComponent: (props) => {
            let color = 'black';
            let backgroundColor = 'white';
            if ((['possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'insignificant')
                || (['unlikely', 'rare', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && ['insignificant', 'minor'].includes(props.rowData.inherentRiskConsequence))) {
                color = 'green';
                props.rowData.calculatedInherentRisk = '1 Low';
            } else if ((props.rowData.inherentRiskLikelihood === 'likely' && props.rowData.inherentRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                props.rowData.calculatedInherentRisk = '2 Moderate';
            } else if ((props.rowData.inherentRiskLikelihood === 'certain' && props.rowData.inherentRiskConsequence === 'insignificant')
                || (['certain', 'likely', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'major')
                || (props.rowData.inherentRiskLikelihood === 'rare' && props.rowData.inherentRiskConsequence === 'catastrophic')
            ) {
                color = 'orange';
                props.rowData.calculatedInherentRisk = '3 High';
            } else if ((props.rowData.inherentRiskLikelihood === 'certain' && props.rowData.inherentRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(props.rowData.inherentRiskLikelihood) && props.rowData.inherentRiskConsequence === 'catastrophic')
            ) {
                color = 'red';
                props.rowData.calculatedInherentRisk = '4 Acute';
            }
            return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{props.rowData.calculatedInherentRisk}</div>;
        },
        render: (rowData) => {
            let color = 'black';
            let backgroundColor = 'white';
            let calculatedInherentRisk = '';
            if ((['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'insignificant')
                || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && ['insignificant', 'minor'].includes(rowData.inherentRiskConsequence))) {
                color = 'green';
                calculatedInherentRisk = '1 Low';
            } else if ((rowData.inherentRiskLikelihood === 'likely' && rowData.inherentRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                calculatedInherentRisk = '2 Moderate';
            } else if ((rowData.inherentRiskLikelihood === 'certain' && rowData.inherentRiskConsequence === 'insignificant')
                || (['certain', 'likely', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'major')
                || (rowData.inherentRiskLikelihood === 'rare' && rowData.inherentRiskConsequence === 'catastrophic')
            ) {
                color = 'orange';
                calculatedInherentRisk = '3 High';
            } else if ((rowData.inherentRiskLikelihood === 'certain' && rowData.inherentRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.inherentRiskConsequence === 'catastrophic')
            ) {
                color = 'red';
                calculatedInherentRisk = '4 Acute';
            }
            return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{calculatedInherentRisk}</div>;
        }
    },
    { title: 'Control Measure', field: 'controlMeasure', type: "textarea", headerStyle: { width: "25%", background: "lightblue" } },
    { title: 'Consequence',
        field: 'residualRiskConsequence',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: { insignificant : 'Insignificant / Acceptable' , minor : 'Minor', moderate: 'Moderate', major: 'Major', catastrophic: 'Catastrophic' },
    },
    { title: 'Likelihood',
        field: 'residualRiskLikelihood',
        headerStyle: { width: "15%", background: "lightblue" },
        lookup: { certain : 'Almost certain' , likely : 'Likely', possible: 'Possible', unlikely: 'Unlikely', rare: 'Rare' },
    },
    {
        title: 'Residual Risk Rating',
        field: 'calculateResidualRisk',
        editComponent: (props) => {
            let color = 'black';
            let backgroundColor = 'white';
            if ((['possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'insignificant')
                || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && ['insignificant', 'minor'].includes(props.rowData.residualRiskConsequence))) {
                color = 'green';
                props.rowData.calculateResidualRisk = '1 Low';
            } else if ((props.rowData.residualRiskLikelihood === 'likely' && props.rowData.residualRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                props.rowData.calculateResidualRisk = '2 Moderate';
            } else if ((props.rowData.residualRiskLikelihood === 'certain' && props.rowData.residualRiskConsequence === 'insignificant')
                || (['certain', 'likely'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'major')
                || (props.rowData.residualRiskLikelihood === 'rare' && props.rowData.residualRiskConsequence === 'catastrophic')
            ) {
                color = 'orange';
                props.rowData.calculateResidualRisk = '3 High';
            } else if ((props.rowData.residualRiskLikelihood === 'certain' && props.rowData.residualRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely'].includes(props.rowData.residualRiskLikelihood) && props.rowData.residualRiskConsequence === 'catastrophic')
            ) {
                color = 'red';
                props.rowData.calculateResidualRisk = '4 Acute';
            }
            return <div style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{props.rowData.calculateResidualRisk}</div>;
        },
        render: (rowData) => {
            let color = 'black';
            let backgroundColor = 'white';
            let calculateResidualRisk = '';
            if ((['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.residualRiskConsequence === 'insignificant')
                || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && ['insignificant', 'minor'].includes(rowData.residualRiskConsequence))) {
                color = 'green';
                calculateResidualRisk = '1 Low';
            } else if ((rowData.residualRiskLikelihood === 'likely' && rowData.residualRiskConsequence === 'insignificant')
                || (['possible', 'moderate'].includes(rowData.inherentRiskLikelihood) && rowData.residualRiskConsequence === 'minor')
                || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'moderate')) {
                color = 'yellow';
                backgroundColor = 'gray';
                calculateResidualRisk = '2 Moderate';
            } else if ((rowData.residualRiskLikelihood === 'certain' && rowData.residualRiskConsequence === 'insignificant')
                || (['certain', 'likely'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'minor')
                || (['likely', 'possible', 'moderate'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'moderate')
                || (['unlikely', 'rare'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'major')
                || (rowData.residualRiskLikelihood === 'rare' && rowData.residualRiskConsequence === 'catastrophic')
            ) {
                color = 'orange';
                calculateResidualRisk = '3 High';
            } else if ((rowData.residualRiskLikelihood === 'certain' && rowData.residualRiskConsequence === 'moderate')
                || (['certain', 'likely', 'possible'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'major')
                || (['certain', 'likely', 'possible', 'unlikely'].includes(rowData.residualRiskLikelihood) && rowData.residualRiskConsequence === 'catastrophic')
            ) {
                color = 'red';
                calculateResidualRisk = '4 Acute';
            }
            return <span style={{ color: color, background: backgroundColor, textAlign: 'center' }}>{calculateResidualRisk}</span>;
        }
    }
];

const muiColumnsHazardsWorkers = [
    { title: 'Worker Name', field: 'name'},
    { title: 'Job Role / Position', field: 'jobTitle', headerStyle: { width: "20%" } },
    { title: 'Company', field: 'company', headerStyle: { width: "20%" } },
    { title: 'Signature', field: 'signature', type: "signature", headerStyle: { width: "20%" } },
    { title: 'Date', field: 'date', type: "date", headerStyle: { width: "20%" } },
];

class SwmsHazards extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            id: props.state.id,
            hazards: this.props.state.hazards,
            hazardsWorkers: this.props.state.hazardsWorkers,
        };
        this.onChange = this.onChange.bind(this);
        this.onDateChange = this.onDateChange.bind(this);
        this.onModalOpen = this.onModalOpen.bind(this);
        this.onModalClose = this.onModalClose.bind(this);
        this.isValid = this.isValid.bind(this);
        this.onSignatureDrawn = this.onSignatureDrawn.bind(this);
        this.handleAddHazard = this.handleAddHazard.bind(this);
        this.handleAddHazardWorker = this.handleAddHazardWorker.bind(this);
        this.handleUpdateHazards = this.handleUpdateHazards.bind(this);
        this.handleUpdateHazardWorker = this.handleUpdateHazardWorker.bind(this);
        this.handleDeleteHazard = this.handleDeleteHazard.bind(this);
        this.handleDeleteHazardWorker = this.handleDeleteHazardWorker.bind(this);
    }

    saveSwms(isContinueEditing) {
        this.props.saveSwms(isContinueEditing, this.state.hazards, this.state.hazardsWorkers);
    }

    handleAddHazard(data) {
        let list = this.state.hazards;
        list.push(data);
        this.setState({
            hazards: list
        }, () => this.saveSwms(true));
    }

    handleAddHazardWorker(data) {
        let list = this.state.hazardsWorkers;
        list.push(data);
        this.setState({
            hazardsWorkers: list
        }, () => this.saveSwms(true));
    }

    handleDeleteHazard(toDelete) {
        let hazards = [];
        const index = this.state.hazards.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.hazards.length; i < l; i++) {
            if (i !== index) {
                hazards.push(this.state.hazards[i]);
            }
        }
        this.setState({hazards: hazards}, () => this.saveSwms(true));
    }

    handleDeleteHazardWorker(toDelete) {
        let hazardsWorkers = [];
        const index = this.state.hazardsWorkers.findIndex(x => x.id === toDelete.id);
        for (let i = 0, l = this.state.hazardsWorkers.length; i < l; i++) {
            if (i !== index) {
                hazardsWorkers.push(this.state.hazardsWorkers[i]);
            }
        }
        this.setState({hazardsWorkers: hazardsWorkers}, () => this.saveSwms(true));
    }

    handleUpdateHazards(toUpdate) {
        for (let i = 0, l = this.state.hazards.length; i < l; i++) {
            if (this.state.hazards[i].id === toUpdate.id) {
                this.state.hazards[i].jobStep = toUpdate.jobStep;
                this.state.hazards[i].inherentRiskLikelihood = toUpdate.inherentRiskLikelihood;
                this.state.hazards[i].inherentRiskConsequence = toUpdate.inherentRiskConsequence;
                this.state.hazards[i].controlMeasure = toUpdate.controlMeasure;
                this.state.hazards[i].residualRiskLikelihood = toUpdate.residualRiskLikelihood;
                this.state.hazards[i].residualRiskConsequence = toUpdate.residualRiskConsequence;
            }
        }
        this.saveSwms(true);
    }

    handleUpdateHazardWorker(toUpdate) {
        for (let i = 0, l = this.state.hazardsWorkers.length; i < l; i++) {
            if (this.state.hazardsWorkers[i].id === toUpdate.id) {
                this.state.hazardsWorkers[i].name = toUpdate.name;
                this.state.hazardsWorkers[i].signature = toUpdate.signature;
                this.state.hazardsWorkers[i].jobTitle = toUpdate.jobTitle;
                this.state.hazardsWorkers[i].company = toUpdate.company;
                this.state.hazardsWorkers[i].date = toUpdate.date;
            }
        }
        this.saveSwms(true);
    }

    onChange(event) {
        console.log('on change called');
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [event.target.name]: event.target.value
        });
    }
    isValid(data) {
        return true;
    }
    onDateChange(date, fieldName) {
        console.log('on date change called');
        this.props.onChangeHandler();
        this.setState({
            ...this.state, [fieldName]: moment(date, "DD/MM/YYYY"),
        });
    }

    onModalOpen() {
        this.setState({
            zoomedInModalShow: true,
        });
    }

    onModalClose() {
        this.setState({
            zoomedInModalShow: false,
        });
    }

    onSignatureDrawn(fileName, sigPad) {
        console.log('on signature drawn called');
        this.props.onChangeHandler();
        this.props.onSignatureDrawn(fileName, sigPad);
    }

    render() {
        let {state} = this;

        return <React.Fragment>
            <Accordion defaultExpanded>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreTwoTone />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ backgroundColor: 'blue', color: 'white'}}
            >
                <Grid item xs={8}>
                    <Typography component="h6" variant="subtitle1">
                        SWMS Scope
                    </Typography>
                </Grid>
                <Grid item xs={4}>
                    <Typography component="h6" variant="subtitle1">
                        High Risk Construction Work
                    </Typography>
                </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ padding: '0px' }}>
                <SwmsPartThree state={this.state} onChangeHandler={this.props.onChangeHandler}/>
            </ExpansionPanelDetails>
        </Accordion>
        <Accordion defaultExpanded>
            <ExpansionPanelSummary
                expandIcon={<ExpandMoreTwoTone />}
                aria-controls="panel1a-content"
                id="panel1a-header"
                style={{ backgroundColor: 'blue', color: 'white'}}
            >
                <Grid item xs={12}>
                    <Typography component="h6" variant="subtitle1">
                        RISK ASSESSMENT MATRIX
                    </Typography>
                </Grid>
            </ExpansionPanelSummary>
            <ExpansionPanelDetails style={{ padding: '0px' }}>
                <Grid container spacing={0}>
                    <Grid item xs={12}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="3">STEP 1: Determine the likelihood</th>
                                </tr>
                                <tr>
                                    <th style={{padding: "20px", width: "20%"}}/>
                                    <th style={{ padding: "20px", width: "40%" }}>Criteria</th>
                                    <th style={{ padding: "20px", width: "40%" }}>Description</th>
                                </tr>
                            </TableHead>
                            <TableBody>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Almost Certain</td>
                                    <td style={{ padding: "20px" }}>Expected in most circumstances</td>
                                    <td style={{ padding: "20px" }}>Effect is a common result.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Likely</td>
                                    <td style={{ padding: "20px" }}>Will probably occur in most circumstances.</td>
                                    <td style={{ padding: "20px" }}>Effect is known to have occurred at this site or it has happened</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Possible</td>
                                    <td style={{ padding: "20px" }}>Might occur in some time</td>
                                    <td style={{ padding: "20px" }}>Effect could occur at the site or I’ve heard of it happenin</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Unlikely</td>
                                    <td style={{ padding: "20px" }}>Could occur at some time.</td>
                                    <td style={{ padding: "20px" }}>Effect could occur at the site or I’ve heard of it happening.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Rare</td>
                                    <td style={{ padding: "20px" }}>May occur only in exceptional circumstances.</td>
                                    <td style={{ padding: "20px" }}>Effect is practically impossible.</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="3">STEP 2: Determine the consequence<br/>What will be the expected effect?</th>
                                </tr>
                                <tr>
                                    <th style={{padding: "20px", width: "20%"}}>Level of effect</th>
                                    <th style={{ padding: "20px", width: "80%" }}>Example of each level</th>
                                </tr>
                            </TableHead>
                            <TableBody>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Insignificant / acceptable</td>
                                    <td style={{ padding: "20px" }}>No effect – or so minor that effect is acceptable.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Minor</td>
                                    <td style={{ padding: "20px" }}>First Aid treatment only. No lost time injury.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Moderate</td>
                                    <td style={{ padding: "20px" }}>Medical treatment, serious injuries, temporary partial disability, lost time injury &lt; 7 days</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Major</td>
                                    <td style={{ padding: "20px" }}>Hospital admittance, extensive injuries, lost time injury &gt; 7 days. Permanent total disability injury, death</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Catastrophic</td>
                                    <td style={{ padding: "20px" }}>Multiple permanent total disability injuries, multiple death</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="6">STEP 3: Determine the risk score</th>
                                </tr>
                                <tr>
                                    <th colSpan="6" style={{padding: "20px", width: "20%"}}>Consequence</th>
                                </tr>
                            </TableHead>
                            <TableBody>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Likelihood</td>
                                    <td style={{ padding: "20px" }}>Insignificant</td>
                                    <td style={{ padding: "20px" }}>Minor</td>
                                    <td style={{ padding: "20px" }}>Moderate</td>
                                    <td style={{ padding: "20px" }}>Major</td>
                                    <td style={{ padding: "20px" }}>Catastrophic</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Almost certain</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 HIGH</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 HIGH</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Likely</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>2 Moderate</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 High</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 High</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Possible</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>1 Low</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>2 Moderate</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 High</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Unlikely</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>1 Low</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>1 Low</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>2 Moderate</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 High</td>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4 Acute</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "lightblue" }}>Rare</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>1 Low</td>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>1 Low</td>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>2 Moderate</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 High</td>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3 High</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <Table>
                            <TableHead style={{ backgroundColor: "lightblue" }}>
                                <tr style={{ textAlign: "left" }}>
                                    <th style={{ padding: "20px" }} colSpan="2">STEP 4: RISK ASSESSMENT<br/>Step 1 + Step 2 + Step 3 = Step 4 Risk assessment</th>
                                </tr>
                                <tr>
                                    <th style={{padding: "20px", width: "20%"}}>Score</th>
                                    <th style={{ padding: "20px", width: "80%" }}>Action</th>
                                </tr>
                            </TableHead>
                            <TableBody style={{ textAlign: "center" }}>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "red" }}>4<br/>A: Acute</td>
                                    <td style={{ padding: "20px" }}><b>Do not proceed—STOP WORK.</b> Requires immediate action. Introduce further high level controls to lower the risk level. Re-assess before proceeding.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "orange" }}>3<br/>H: High</td>
                                    <td style={{ padding: "20px" }}><b>Review before commencing work.</b> Introduce new controls and/or maintain high level controls to lower the risk level. Monitor frequently to ensure control measures are working.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "yellow" }}>2<br/>M: Moderate</td>
                                    <td style={{ padding: "20px" }}><b>Maintain control measures.</b> Proceed with work. Monitor and review regularly, and assess if any equipment/materials/work processes or procedures need to be changed.</td>
                                </tr>
                                <tr>
                                    <td style={{ padding: "20px", backgroundColor: "green" }}>1<br/>L: Low</td>
                                    <td style={{ padding: "20px" }}><b>Record and monitor.</b> Proceed with work. Review regularly, and if any equipment/people/materials work processes or procedures need to be revised.</td>
                                </tr>
                            </TableBody>
                        </Table>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <div style={{ backgroundColor: 'yellow', padding: "30px" }}>
                            <Typography component="h6" variant="subtitle1">
                                IR: Inherent risk rating
                            </Typography>
                            <br/>
                            <Typography component="h6" variant="subtitle2">
                                RR: Residual risk rating
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper square>
                            <MuiTable
                                title="HAZARDS / RISKS / CONTROL MEASURE"
                                columns={muiColumnsHazards}
                                data={state.hazards}
                                onAdd={this.handleAddHazard}
                                onUpdate={this.handleUpdateHazards}
                                onDelete={this.handleDeleteHazard}
                                isValid={this.isValid}
                                exportButton={false}
                                search={false}
                                pageSize={20}
                                headerStyle={{ background: "lightblue" }}
                            />
                        </Paper>
                    </Grid>
                    <Grid item xs={12} style={{ paddingTop: "30px" }}>
                        <div style={{ backgroundColor: 'yellow', padding: "30px" }}>
                            <Typography component="h6" variant="subtitle1">
                                This SWMS has been developed in consultation and cooperation with all workers undertaking this project and relevant Persons Conducting Business or Undertaking (PCBU) employees.
                            </Typography>
                            <br/>
                            <Typography component="h6" variant="subtitle2">
                                Only persons who have completed the signoff are authorised to work on the relevant tasks covered in this
                            </Typography>
                        </div>
                    </Grid>
                    <Grid item xs={12}>
                        <Paper square>
                            <MuiTable
                                title="HAZARDS"
                                columns={muiColumnsHazardsWorkers}
                                data={state.hazardsWorkers}
                                onAdd={this.handleAddHazardWorker}
                                onUpdate={this.handleUpdateHazardWorker}
                                onDelete={this.handleDeleteHazardWorker}
                                isValid={this.isValid}
                                exportButton={false}
                                search={false}
                                pageSize={20}
                                headerStyle={{ background: "lightblue" }}
                            />
                        </Paper>
                    </Grid>
                </Grid>
            </ExpansionPanelDetails>
        </Accordion>
        </React.Fragment>;
    }
}

export default withStyles(classes)(SwmsHazards);